// src/utils/pwaInstall.js
// Captures the `beforeinstallprompt` event as early as possible (this module is
// imported from index.js) so it is not lost when it fires before the component
// that shows the install button has mounted (e.g. while the user is on /login).

let deferredPrompt = null;
let installed = false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });

  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    installed = true;
    notify();
  });
}

export const subscribe = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const getDeferredPrompt = () => deferredPrompt;

export const promptInstall = async () => {
  if (!deferredPrompt) return null;
  const prompt = deferredPrompt;
  prompt.prompt();
  const choice = await prompt.userChoice;
  // A prompt can only be used once.
  deferredPrompt = null;
  if (choice.outcome === 'accepted') installed = true;
  notify();
  return choice.outcome;
};

export const isStandalone = () =>
  installed ||
  window.matchMedia?.('(display-mode: standalone)').matches ||
  window.matchMedia?.('(display-mode: fullscreen)').matches ||
  window.matchMedia?.('(display-mode: minimal-ui)').matches ||
  window.navigator.standalone === true; // iOS Safari

// Returns one of: 'ios' | 'android' | 'mac-safari' | 'other'
export const getPlatform = () => {
  const ua = window.navigator.userAgent || '';
  // iPadOS 13+ reports itself as "Macintosh"; detect it via touch support.
  const isIPadOS = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  if (/iPhone|iPad|iPod/.test(ua) || isIPadOS) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  const isSafari = /Safari/.test(ua) && !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS/.test(ua);
  if (/Macintosh/.test(ua) && isSafari) return 'mac-safari';
  return 'other';
};
